import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { getOnboardingStateGQL } from '@confluence/onboarding-helpers/entry-points/getOnboardingStateGQL.ts';
import {
	PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS,
	ONBOARDING_EXPERIENCES,
} from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';

export const preloadPersonalizedTemplatesV2OnboardingState = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: [
				ONBOARDING_EXPERIENCES.IS_FOUNDING_ADMIN,
				...Object.values(PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS),
			],
		},
	});
};
